import timer from '@devices/settings/device_settings/timer.js';
import schedule from '@devices/settings/device_settings/schedule.js';
import internet from '@devices/settings/device_settings/internet.js';
import safety from '@devices/settings/device_settings/safety.js';
import actions from '@devices/settings/device_settings/actions.js';
import temperature_actions from '@devices/settings/device_settings/temperature_actions.js';
import humidity_actions from '@devices/settings/device_settings/humidity_actions.js';
import external_sensors from '@devices/settings/device_settings/external_sensors.js';
import share from '@devices/settings/device_settings/share.js';
import { createSceneCapabilities } from '@components/Flows/sceneCapabilities/index.js';

export default {
	name: 'shellyair',
	friendly_name: 'Air',
	family: 'relay',
	isPM: false,
	modes: {
		relay: {
			sceneCapabilities: createSceneCapabilities({
				template: 'single_relay_gen1',
			}),
			channels: 1,
			notifications: ['offline', 'device_problem'],
			settings: [
				timer,
				schedule,
				internet,
				safety,
				actions,
				temperature_actions,
				humidity_actions,
				{
					title: 'settings',
					components: [
						{ title: 'eco_mode', component: 'eco_mode' },
						{ title: 'power_on', component: 'power_on_default' },
						{ title: 'appliance_type', component: 'appliance_type_g1' },
						{ title: 'button_type', component: 'button_type' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{
							title: 'geo_location_and_time_zone',
							component: 'geo_location_and_time_zone',
						},
						{ title: 'channel_name', component: 'channel_name' },
						{ title: 'factory_reset', component: 'factory_reset_g1' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
				external_sensors,
				share,
				{
					title: 'application_settings',
					components: [
						{
							title: 'device_card_customization',
							component: 'customize_device_content',
						},
						{ title: 'appliance_type', component: 'appliance_type' },
						{
							title: 'consumption_calculation',
							component: 'consumption_calculation',
						},
						{
							title: 'consumption_hierarchy',
							component: 'consumption_hierarchy',
							test_user: true,
						},
						{ title: 'pin_lock', component: 'pin_lock' },
						{ title: 'exclude_event_log', component: 'exclude_event_log' },
					],
				},
			],
		},
	},
};
